import { z } from 'zod';
import { PlayerColor } from './PlayerState.ts';
import { createNumericKeyRecordSchema } from './KeyRecordSchemas.ts';
import { uniquePlayerColorsArraySchema } from './SharedZodSchemas.ts';
import { validateState } from './ValidateState.ts';
export var GameChatType = /*#__PURE__*/ function(GameChatType) {
    GameChatType[GameChatType["Message"] = 0] = "Message";
    GameChatType[GameChatType["SystemMessage"] = 1] = "SystemMessage";
    GameChatType[GameChatType["UnableToSend"] = 2] = "UnableToSend";
    GameChatType[GameChatType["ChatDisabled"] = 3] = "ChatDisabled";
    GameChatType[GameChatType["ChatEnabled"] = 4] = "ChatEnabled";
    GameChatType[GameChatType["BadLanguage"] = 5] = "BadLanguage";
    GameChatType[GameChatType["TooLong"] = 6] = "TooLong";
    GameChatType[GameChatType["Spam"] = 7] = "Spam";
    GameChatType[GameChatType["WrongCommand"] = 8] = "WrongCommand";
    GameChatType[GameChatType["CommandCrashed"] = 9] = "CommandCrashed";
    GameChatType[GameChatType["GameCommandOnly"] = 10] = "GameCommandOnly";
    GameChatType[GameChatType["EmojiTutorial"] = 11] = "EmojiTutorial";
    GameChatType[GameChatType["CommandTutorial"] = 12] = "CommandTutorial";
    GameChatType[GameChatType["DisableKarmaTutorial"] = 13] = "DisableKarmaTutorial";
    GameChatType[GameChatType["PauseGameTutorial"] = 14] = "PauseGameTutorial";
    GameChatType[GameChatType["SpectatorCannotSendMessage"] = 15] = "SpectatorCannotSendMessage";
    GameChatType[GameChatType["YouAreMuted"] = 16] = "YouAreMuted";
    GameChatType[GameChatType["AdminKickedPlayer"] = 17] = "AdminKickedPlayer";
    GameChatType[GameChatType["CanOnlyResignIn1v1"] = 18] = "CanOnlyResignIn1v1";
    return GameChatType;
}({});
export const gameChatMessageDataSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal(0),
        message: z.string(),
        from: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(1),
        message: z.string()
    }).strict(),
    z.object({
        type: z.literal(2)
    }).strict(),
    z.object({
        type: z.literal(3)
    }).strict(),
    z.object({
        type: z.literal(4)
    }).strict(),
    z.object({
        type: z.literal(5)
    }).strict(),
    z.object({
        type: z.literal(6)
    }).strict(),
    z.object({
        type: z.literal(7)
    }).strict(),
    z.object({
        type: z.literal(8)
    }).strict(),
    z.object({
        type: z.literal(9)
    }).strict(),
    z.object({
        type: z.literal(10)
    }).strict(),
    z.object({
        type: z.literal(11),
        exampleString: z.string(),
        exampleEmojis: z.string()
    }).strict(),
    z.object({
        type: z.literal(12),
        exampleString: z.string()
    }).strict(),
    z.object({
        type: z.literal(13),
        exampleString: z.string()
    }).strict(),
    z.object({
        type: z.literal(14),
        exampleString: z.string()
    }).strict(),
    z.object({
        type: z.literal(15)
    }).strict(),
    z.object({
        type: z.literal(16),
        mutedUntil: z.string()
    }).strict(),
    z.object({
        type: z.literal(17)
    }).strict(),
    z.object({
        type: z.literal(18)
    }).strict()
]);
export const gameChatDataSchema = z.object({
    text: gameChatMessageDataSchema,
    recipients: uniquePlayerColorsArraySchema.exactOptional(),
    toSpectators: z.literal(false).exactOptional()
}).strict();
export function validateGameChatData(data) {
    return validateState(gameChatDataSchema, data);
}
export const gameChatStateSchema = createNumericKeyRecordSchema(gameChatDataSchema);
export function validateGameChatState(data) {
    return validateState(gameChatStateSchema, data);
}
export const gameChatStatePartialSchema = createNumericKeyRecordSchema(gameChatDataSchema, {
    requireAtLeastOneEntry: true
});
export function validateGameChatStatePartial(data) {
    return validateState(gameChatStatePartialSchema, data);
}
